/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiEnvProjectFromJSON, ApiEnvProjectToJSON, } from './ApiEnvProject';
import { ApiSimpleContractFromJSON, ApiSimpleContractToJSON, } from './ApiSimpleContract';
import { ApiSimpleProductFromJSON, ApiSimpleProductToJSON, } from './ApiSimpleProduct';
import { ApiSubscriptionMerchantFromJSON, ApiSubscriptionMerchantToJSON, } from './ApiSubscriptionMerchant';
import { ApiSubscriptionStatusFromJSON, ApiSubscriptionStatusToJSON, } from './ApiSubscriptionStatus';
import { ApiSubscriptionTierFromJSON, ApiSubscriptionTierToJSON, } from './ApiSubscriptionTier';
export function ApiSimpleSubscriptionFromJSON(json) {
    return ApiSimpleSubscriptionFromJSONTyped(json, false);
}
export function ApiSimpleSubscriptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aiCredits': !exists(json, 'aiCredits') ? undefined : json['aiCredits'],
        'annualPrice': !exists(json, 'annualPrice') ? undefined : json['annualPrice'],
        'contract': !exists(json, 'contract') ? undefined : ApiSimpleContractFromJSON(json['contract']),
        'contractId': !exists(json, 'contractId') ? undefined : json['contractId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'maxOrders': !exists(json, 'maxOrders') ? undefined : json['maxOrders'],
        'maxPageviews': !exists(json, 'maxPageviews') ? undefined : json['maxPageviews'],
        'maxRevenue': !exists(json, 'maxRevenue') ? undefined : json['maxRevenue'],
        'merchant': !exists(json, 'merchant') ? undefined : ApiSubscriptionMerchantFromJSON(json['merchant']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'product': !exists(json, 'product') ? undefined : ApiSimpleProductFromJSON(json['product']),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        '_public': !exists(json, 'public') ? undefined : json['public'],
        'status': !exists(json, 'status') ? undefined : ApiSubscriptionStatusFromJSON(json['status']),
        'subscribed': !exists(json, 'subscribed') ? undefined : (json['subscribed'].map(ApiEnvProjectFromJSON)),
        'tier': !exists(json, 'tier') ? undefined : ApiSubscriptionTierFromJSON(json['tier']),
    };
}
export function ApiSimpleSubscriptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aiCredits': value.aiCredits,
        'annualPrice': value.annualPrice,
        'contract': ApiSimpleContractToJSON(value.contract),
        'contractId': value.contractId,
        'description': value.description,
        'id': value.id,
        'maxOrders': value.maxOrders,
        'maxPageviews': value.maxPageviews,
        'maxRevenue': value.maxRevenue,
        'merchant': ApiSubscriptionMerchantToJSON(value.merchant),
        'name': value.name,
        'price': value.price,
        'product': ApiSimpleProductToJSON(value.product),
        'productId': value.productId,
        'public': value._public,
        'status': ApiSubscriptionStatusToJSON(value.status),
        'subscribed': value.subscribed === undefined ? undefined : (value.subscribed.map(ApiEnvProjectToJSON)),
        'tier': ApiSubscriptionTierToJSON(value.tier),
    };
}
